<template>
  <div>
    <div class="fullscreen-modal__content">
      <page>
        <page-title>
          {{ $t('c.mailingOverlay.stepTags.title') }}
        </page-title>

        <draggable
          v-model="tags"
          :options="dragOptions"
          @start="drag=true"
          @end="drag=false"
        >
          <list-item
            v-for="tag in tags"
            :key="tag.id"
            :title="tag.name"
            :subline="$tc('counts.articles', tag.contents.length, {count: tag.contents.length})"
            :sortable="true"
            :switch-value="isTagSelected(tag)"
            @switch-input="selectTag(tag)"
          />
        </draggable>
      </page>
    </div>
    <div class="fullscreen-modal__footer">
      <div class="container">
        <div class="row">
          <div class="col-xs-6 col-lg-4 push-lg-2">
            <button-input
              v-t="'c.mailingOverlay.stepTags.btnNext'"
              :is-disabled="stepIsInvalid"
              @click="nextStep"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import FormMixin from '@/mixins/forms/Form'
import PageMixin from '@/mixins/pages/Page'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import draggable from 'vuedraggable'
import ListItem from '@/components/ui/ListItem'

export default {
  mixins: [FormMixin, PageMixin],
  components: {
    FontAwesomeIcon,
    draggable,
    ListItem
  },
  data () {
    return {
      contents: []
    }
  },
  computed: {
    ...mapGetters ({
      isTagSelected: 'mailing/entry/isTagSelected',
      selectedTags: 'mailing/entry/selectedTags'
    }),
    dragOptions () {
      return {
        handle: '.list-item__handle'
      }
    },
    stepIsInvalid () {
      return this.selectedTags.length === 0
    },
    tags: {
      get () { return this.$store.state.mailing.entry.groupedContents },
      set (value) { this.$store.dispatch('mailing/entry/setGroupedContents', value) }
    }
  },
  methods: {
    ...mapActions ({
      selectTag: 'mailing/entry/selectTag',
      nextStep: 'mailing/step/next'
    })
  }
}
</script>

<style lang="sass">
.controls
  display: flex
  flex-direction: row
  justify-content: flex-end
  align-items: center
  margin-bottom: 30px

  &__dropdown-wrap
    position: relative
    margin-left: 10px

.articles-list
  border-top: 1px solid #e1e5ea

  &__item
    display: flex
    flex-direction: row
    justify-content: space-between
    align-items: center
    height: 100px
    font-size: 22px
    border-bottom: 1px solid #e1e5ea

  &__title
    font-weight: 600

</style>




// WEBPACK FOOTER //
// src/components/mailings/steps/Tags.vue